import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipoActualizacionCreateComponent } from './tipo-actualizacion-create/tipo-actualizacion-create.component';
import { TipoActualizacionIndexComponent } from './tipo-actualizacion-index/tipo-actualizacion-index.component';
import { TipoActualizacionUpdateComponent } from './tipo-actualizacion-update/tipo-actualizacion-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { IConfig } from 'ngx-mask'

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'index', component: TipoActualizacionIndexComponent },
];

@NgModule({
  declarations: [
    TipoActualizacionCreateComponent,
    TipoActualizacionIndexComponent,
    TipoActualizacionUpdateComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule
  ]
})
export class TipoActualizacionModule { }
